import api from './api';

export const sendSupportMessage = async ({ subject, message }) => {
  const response = await api.post('/support', { subject, message });
  return response.data;
};
